import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { OrganizationParametersModel } from '@synthroneApp/models/organization-parameters/organization-parameters.model';

import { ApiService, MessagesService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';

@Component({
	selector: 'app-organization-parameters-view',
	templateUrl: './organization-parameters-view.component.html',
	styleUrls: ['./organization-parameters-view.component.scss']
})
export class OrganizationParametersViewComponent implements OnInit {

	isDataLoading : number = 0;
	orgId : any;
	public parameters: OrganizationParametersModel;

	constructor(private  _router : Router, protected api: ApiService,
		private messagesService:MessagesService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog) {
	}

	ngOnInit() {
		this.orgId = (this._router.url).match(/\d+/)[0];
		this.parameters = {
			serviceCallbackEnabled: null,
			serviceCallbackUrl: null,
			serviceCallbackUsername: null,
			serviceCallbackPassword: null,
			crafterTemplate: null,
			browserS3Bucket: null,
			browserMaxBandwidth: null,
			browserSearchEndpoint: null
		};
		this.isDataLoading++;
		this.api.makeRequest('api_client_parameters_details', {
			id: this.orgId
		}, 'manager').catch( 
			(err:any) => {
				var errorMsg = err || 'Could not get list of parameters';
				return Observable.throw(errorMsg)
			}).subscribe(
			(result) => {
				this.isDataLoading--;
				this.parameters = result;
			}, 
			(error) => {
				this.isDataLoading--;
				this.messagesService.showSnack(error, "error").afterDismissed().subscribe(result => {
					this.homeReturnFN();
				});
			});
		}


		homeReturnFN = () => {
			this._router.navigate(['/organizations']);
		}

		submitFN(isValid: boolean) {
			this.isDataLoading++;
			this.parameters.id = this.orgId;
			this.api.makeRequest('api_client_parameters_edit', this.parameters, 'manager').subscribe(
				(result) => {
					this.isDataLoading--;
					this.homeReturnFN();
				},
				(error) => {
					this.isDataLoading--;
					
					this.messagesService.showSnack(error, "error");
				});
		}

	}



// WEBPACK FOOTER //
// ./src/app/components/views/organization-parameters-view/organization-parameters-view.component.ts